/**!
 * Created by Leonardo Cheslacki on 20/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import SupportController from './SupportController';

import {HelpersPin} from './../helpers';

import Big from 'big.js';

import config from '../../../../config';

const {default: {select, text}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class SupportSelect extends SupportController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            data: [] || {},
            pressed: false,
            invert: false,
            original: {
                occ_body: {
                    x: 0,
                    y: 0,
                    scale_x: 0,
                    scale_y: 0
                },
                occ_button: {
                    x: 0,
                    y: 0,
                    scale_x: 0,
                    scale_y: 0
                }
            },
            control: {
                big_speed_y: this.$controller.big_0,
                big_pressed_y: this.$controller.big_0,
                big_scroll_down_y: this.$controller.big_0,
                big_scroll_up_y: this.$controller.big_0,
                big_button_down_y: this.$controller.big_0,
                big_button_up_y: this.$controller.big_0
            }
        };

        this.$plus = this.$controller.big_0;

        this.isSelect = false;

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         * @param stage
         * @param occ_body
         * @param occ_button
         * @param occ_icon
         * @param big_button_friction
         */
        update: function (event, {stage, occ_body, occ_button, occ_icon, big_button_friction}) {
            let
                {pressed, control} = _this.state,
                {friction} = _this.props,
                big_mouseY = (new Big(stage.mouseY)),
                big_scroll_y = (new Big(occ_body.y)),
                big_friction = (new Big(friction)),
                big_button_speed_y = control.big_speed_y.times(big_button_friction);

            if (pressed) {
                control.big_speed_y = big_mouseY.minus(control.big_pressed_y).plus(_this.$plus);
            }

            control.big_pressed_y = big_mouseY;
            control.big_speed_y = control.big_speed_y.times(big_friction);

            if (big_scroll_y.lte(control.big_scroll_down_y)) {
                _this.moveOption(occ_body, occ_button, big_button_speed_y);
                occ_icon.occ_up.gotoAndStop('enabled');
            }

            if (big_scroll_y.gte(control.big_scroll_up_y)) {
                _this.moveOption(occ_body, occ_button, big_button_speed_y);
                occ_icon.occ_down.gotoAndStop('enabled');
            }

            if (!pressed) {
                if (big_scroll_y.gte(control.big_scroll_down_y)) {
                    occ_body.y = _this.bigToNumber(control.big_scroll_down_y);
                    occ_button.y = _this.bigToNumber(control.big_button_down_y);
                    occ_icon.occ_up.gotoAndStop('disabled');
                }

                if (big_scroll_y.lte(control.big_scroll_up_y)) {
                    occ_body.y = _this.bigToNumber(control.big_scroll_up_y);
                    occ_button.y = _this.bigToNumber(control.big_button_up_y);
                    occ_icon.occ_down.gotoAndStop('disabled');
                }
            }
        },

        /**
         *
         * @param event
         * @param stage
         * @param invert
         * @param content
         */
        handleSelectMouseDown: function (event, {stage, invert, content}) {
            _this.throttle('handleSelectMouseDown', () => {
                _this.setState({..._this.state, pressed: true, invert: invert}, () => {
                    const {control} = _this.state;
                    control.big_pressed_y = (new Big(stage.mouseY));
                    //content.cursor = 'grabbing';
                });
            }, 100);
        },

        /**
         *
         * @param event
         * @param content
         */
        handleSelectResetMouseDown: function (event, {content}) {
            _this.throttle('handleSelectResetMouseDown', () => {
                _this.setState({..._this.state, pressed: false}, () => {
                    _this.$plus = _this.$controller.big_0;
                    //content.cursor = 'grab';
                });
            }, 100);
        },

        handleSelectButtonMouseDown: function (event, {invert, _this_btn}) {
            _this.throttle('handleSelectButtonMouseDown', () => {
                if (_this_btn.currentLabel === 'enabled') {
                    _this.setState({..._this.state, pressed: true, invert: invert}, () => {
                        if (_this_btn.name === 'occ_up') {
                            _this.$plus = _this.$controller.big_20.neg();
                        } else if (_this_btn.name === 'occ_down') {
                            _this.$plus = _this.$controller.big_20;
                        }
                    });
                }
            }, 100);
        },

        /**
         *
         * @param event
         */
        handleSelectMouseOver: function (event) {
            _this.throttle('handleSelectMouseOver', () => {
                // console.log(event);
            }, 100);
        },

        /**
         *
         * @param event
         * @param text
         * @param value
         */
        handleSelect: function (event, {text, value}) {
            _this.throttle('handleSelect', () => {
                const
                    {_this_class, _select} = _this.props,
                    {occ_text: {occ_value}, occ_placeholder, occ_option} = _select,
                    {placeholder, name} = _select.state;

                _this.clearErrors(name);

                occ_value.text = text;

                occ_placeholder.text = (occ_value.text ? '' : placeholder);

                _this_class.setStates({data: {[name]: value}});

                _this.isSelect = false;

                occ_option.gotoAndPlay('complete');
            }, 100);
        },

        /**
         *
         * @param event
         */
        handleOpenSelect: function (event) {
            _this.throttle('handleOpenSelect', () => {
                const {_select: {occ_option}} = _this.props;

                if (!_this.isSelect) {
                    _this.isSelect = true;
                    occ_option.gotoAndPlay('start');
                } else {
                    _this.isSelect = false;
                    occ_option.gotoAndPlay('complete');
                }
            }, 100);
        }
    };

    clearErrors = (name) => {
        const {clearErrors, _select} = this.props;

        if (this.isFunction(clearErrors)) {
            clearErrors(name);
        } else {
            const {occ_error} = _select;
            occ_error.text = '';
        }
    };

    /**
     *
     * @param occ_body
     * @param occ_button
     * @param big_button_speed_y
     */
    moveOption = (occ_body, occ_button, big_button_speed_y) => {
        let {invert, control} = this.state;

        if (invert) {
            occ_body.y -= this.bigToNumber(control.big_speed_y);
            occ_button.y += this.bigToNumber(big_button_speed_y);
        } else {
            occ_body.y += this.bigToNumber(control.big_speed_y);
            occ_button.y -= this.bigToNumber(big_button_speed_y);
        }
    };

    cloneOption = (_this) => {
        return {
            object: null,
            helpersPin: HelpersPin(_this)({current_name: 'options'}),

            /**
             *
             * @returns {null}
             */
            get optionText() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set optionText(object) {
                this.object = object;
            },

            clone() {
                const {_this_layer: {content_option}} = _this.props;
                this.optionText = content_option.clone();
            },

            /**
             *
             * @param string
             * @param color
             * @param font
             * @param size
             * @param weight
             * @param capitalize
             */
            setText(string, color, font, size, weight, capitalize) {
                const {occ_text} = this.object;
                this.helpersPin.setText(occ_text, string, color, font, size, weight, null, null, capitalize);
            },

            /**
             *
             * @param color
             * @param occ
             */
            setColor(color, occ) {
                const occ_color = _this.verifyField(this.object, occ, false, []);
                this.helpersPin.setColor(occ_color, color);
            },

            /**
             *
             * @param x
             * @param y
             */
            setCoordinate(x, y) {
                this.helpersPin.setCoordinate(this.object, x, y);
            },

            /**
             *
             * @param enabled
             * @param cursor
             */
            setCursor(enabled, cursor) {
                this.helpersPin.setCursor(_this, this.object, enabled, cursor);
            }
        }
    };

    /**
     *
     * @param height
     */
    scanControl = (height) => {
        const
            {original, control} = this.state,
            {_option: {occ_form}, _this_layer, friction} = this.props,
            {stage: {canvas}} = _this_layer,
            {
                occ_icon,
                content_body,
                occ_thumb
            } = occ_form,
            {
                stage,
                occ_body,
                occ_size
            } = content_body,
            {
                occ_button,
                occ_track
            } = occ_thumb,
            {
                occ_up,
                occ_down
            } = occ_icon;

        let
            big_scroll_height = (new Big(height)),
            big_size_height = (new Big(occ_size.nominalBounds.height)),
            big_track_height = (new Big(occ_track.nominalBounds.height)),
            body_scaleY = this.calcSize(big_size_height, big_scroll_height, 1, true),
            button_scaleY = this.calcSize(big_scroll_height, big_size_height, 1),
            big_button_height = this.calcSize(1, button_scaleY, (new Big(occ_button.nominalBounds.height)), true);

        if (body_scaleY.gt(this.$controller.big_1)) {
            control.big_scroll_down_y = (new Big(original.occ_body.y));
            control.big_scroll_up_y = big_size_height.plus(control.big_scroll_down_y).minus(big_scroll_height);

            control.big_button_down_y = (new Big(occ_button.y));
            control.big_button_up_y = big_track_height.plus(control.big_button_down_y).minus(big_button_height.plus(control.big_button_down_y.times(this.$controller.big_2)));

            this._handleSelectMouseDownInvert && occ_thumb.off('mousedown', this._handleSelectMouseDownInvert);
            this._handleSelectMouseDownInvert = occ_thumb.on('mousedown', this.$functions.handleSelectMouseDown, false, false, {
                stage: stage,
                content: occ_thumb,
                invert: true
            });

            this._handleSelectMouseDown && content_body.off('mousedown', this._handleSelectMouseDown);
            this._handleSelectMouseDown = content_body.on('mousedown', this.$functions.handleSelectMouseDown, false, false, {
                stage: stage,
                content: content_body,
                invert: false
            });


            this._handleSelectMouseDownBtnUp && occ_up.off('mousedown', this._handleSelectMouseDownBtnUp);
            this._handleSelectMouseDownBtnUp = occ_up.on('mousedown', this.$functions.handleSelectButtonMouseDown, false, false, {
                stage: stage,
                content: content_body,
                invert: true,
                _this_btn: occ_up
            });

            this._handleSelectMouseDownBtnDown && occ_down.off('mousedown', this._handleSelectMouseDownBtnDown);
            this._handleSelectMouseDownBtnDown = occ_down.on('mousedown', this.$functions.handleSelectButtonMouseDown, false, false, {
                stage: stage,
                content: content_body,
                invert: true,
                _this_btn: occ_down
            });

            this._handleSelectResetMouseDown && stage.off('stagemouseup', this._handleSelectResetMouseDown);
            this._handleSelectResetMouseDown = stage.on('stagemouseup', this.$functions.handleSelectResetMouseDown, false, false, {
                content: content_body
            });

            this._handleSelectMouseOver && stage.off('mouseover', this._handleSelectMouseOver);
            this._handleSelectMouseOver = stage.on('mouseover', this.$functions.handleSelectMouseOver);

            this.main.$supportTouch({
                window: canvas.ownerDocument.defaultView,
                document: canvas.ownerDocument
            }).initTouch();

            // stage.enableMouseOver();
            // stage.mouseMoveOutside = true;
            createjs.Touch.enable(stage);
            // createjs.Ticker.timingMode = createjs.Ticker.RAF;

            this.destroyTicker('_handleTickerSelect');

            let ticker = createjs.Ticker.on('tick', this.$functions.update, false, false, {
                stage: stage,
                occ_body: occ_body,
                occ_button: occ_button,
                occ_icon: occ_icon,
                big_button_friction: this.calcSize(1, button_scaleY, friction, true)
            });

            this.setReferenceTicker('_handleTickerSelect', ticker);

            //content_body.cursor = 'grab';

            occ_button.setTransform(occ_button.x, occ_button.y, occ_button.scaleX, button_scaleY);
        }
    };

    /**
     *
     */
    defineSelect = () => {
        const
            {original} = this.state,
            {
                _this_class, form, _select, _option: {occ_form},
                text: {cursor, text_align, font_size, font, weight}
            } = this.props,
            {content_body: {occ_body}, occ_thumb: {occ_button}} = occ_form,
            {occ_text: {occ_value: {x, lineWidth}}, occ_placeholder: {text}, name, occ_caret, occ_option} = _select;

        let
            state_name = this.verifyField(_select, 'state.name'),
            state_type = this.verifyField(_select, 'state.type'),
            state_value_x = this.verifyField(_select, 'state.value_x'),
            state_caret_x = this.verifyField(_select, 'state.caret_x'),
            state_line_width = this.verifyField(_select, 'state.line_width'),
            state_placeholder = this.verifyField(_select, 'state.placeholder');

        this.isSelect = false;

        occ_option.gotoAndPlay('end');
        occ_body.y = original.occ_body.y;
        occ_button.y = original.occ_button.y;

        _select.cursor = cursor;
        _select.occ_text.occ_value.text = '';
        _select.occ_text.occ_value.font = `${(!this.isEmpty(weight) ? `${weight.toLowerCase()} ` : ``)}${font_size}px '${font}'`;
        _select.occ_text.occ_value.textAlign = text_align;
        state_value_x && (_select.occ_text.occ_value.x = state_value_x);
        state_caret_x && (_select.occ_caret.x = state_caret_x);
        state_placeholder && (_select.occ_placeholder.text = state_placeholder);

        let
            named = `${name.replace(`${form}_`, '')}_id`,
            typed = 'select';

        this.setStateOccurrence(_select, {
            name: state_name ? state_name : named,
            type: state_type ? state_type : typed,
            focus: false,
            value_x: state_value_x ? state_value_x : x,
            caret_x: state_caret_x ? state_caret_x : occ_caret.x,
            line_width: state_line_width ? state_line_width : lineWidth,
            placeholder: state_placeholder ? state_placeholder : text,
            tab_index: null,
            value: '',
            mask: ''
        });

        _this_class.$inputs[named] = _select;
    };

    startSelect = () => {
        const
            {data} = this.state,
            {
                _this_layer: {btn_select},
                _option: {occ_form},
                text: {text_y, color_disabled, color_enabled, font, font_size, weight, capitalize}
            } = this.props,
            {content_body: {occ_body}} = occ_form;

        let y = 0;

        occ_body.removeAllChildren();

        this.recursiveSyncMap(data, 0, data.length, (item, next, stop, index) => {
            const
                text = this.verifyField(item, 'text'),
                value = this.verifyField(item, 'value'),
                selected = this.verifyField(item, 'selected'),
                option = this.cloneOption(this);

            let color_text = selected ? color_disabled : color_enabled;

            /**
             * Clone pin text
             */
            option.clone();

            /**
             * Clone pin text
             */
            option.setText(text, color_text, font, font_size, weight, capitalize);
            option.setCoordinate(0, y);


            if (!selected) {
                /**
                 * Clone pin text
                 */
                option.setCursor(true, 'pointer');


                let _index = this.padWithLeadingZeros(index, 2);

                /**
                 * Clone pin text to select with event click
                 */
                this[`_handleSelect${_index}`] && option.optionText.off('click', this[`_handleSelect${_index}`]);
                this[`_handleSelect${_index}`] = option.optionText.on('click', this.$functions.handleSelect, false, false, {
                    text: text,
                    value: value
                });
            } else {
                /**
                 * Clone pin text
                 */

                option.setCursor(false, 'default');
            }

            occ_body.addChild(option.optionText);

            y += text_y;

            next(true);
        }, () => {
            this.defineSelect();
            this.scanControl(y);

            this._handleOpenSelect && btn_select.off('mousedown', this._handleOpenSelect);
            this._handleOpenSelect = btn_select.on('mousedown', this.$functions.handleOpenSelect);
        });
    };

    initSelect = () => {
        const
            {data, _option: {occ_form}} = this.props,
            {content_body: {occ_body}, occ_thumb: {occ_button}} = occ_form;

        this.setState({
            ...this.state,
            data: data,
            original: {
                occ_body: {
                    x: occ_body.x,
                    y: occ_body.y,
                    scale_x: occ_body.scaleX,
                    scale_y: occ_body.scaleY
                },
                occ_button: {
                    x: occ_button.x,
                    y: occ_button.y,
                    scale_x: occ_button.scaleX,
                    scale_y: occ_button.scaleY
                }
            }
        }, this.startSelect);
    };
}

/**
 *
 * @type {{}}
 */
SupportSelect.propTypes = {
    current_name: PropTypes.string,
    text: PropTypes.shape({
        text_x: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        text_y: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        color_enabled: PropTypes.string,
        color_disabled: PropTypes.string,
        font: PropTypes.string,
        font_size: PropTypes.number,
        weight: PropTypes.oneOf(['normal', 'bold'])
    })
};

/**
 *
 * @type {{}}
 */
SupportSelect.defaultProps = {
    current_name: null,
    ...select,
    text: {...select.text, ...text}
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(SupportSelect, {className: 'SupportSelect'});
